<div [class.hidden]="!initialized">
  <select [id]="id" multiple="multiple" class="{{ class }}"></select>
</div>